import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "relative max-h-full w-full flex flex-col text-main-5"
};
const _hoisted_2 = {
  class: "w-full flex flex-col gap-6 pb-3 border-b border-main-5"
};
const _hoisted_3 = {
  class: "min-h-[36px] flex items-center justify-between flex-wrap gap-x-2 gap-y-4"
};
const _hoisted_4 = {
  class: "flex items-center gap-6"
};
const _hoisted_5 = {
  class: "flex flex-col gap-1"
};
const _hoisted_6 = {
  class: "flex items-center gap-2"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  key: 0,
  class: "h-8 flex items-center gap-2 px-3 border-2 border-second-100 rounded-2xl"
};
const _hoisted_9 = {
  class: "text-xs truncate"
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
  class: "relative h-full w-full flex overflow-hidden"
};
const _hoisted_12 = {
  id: "dynamic-view-scroll",
  class: "w-full overflow-y-auto overflow-x-hidden scroll pr-2"
};
const _hoisted_13 = {
  class: "w-full flex"
};
const _hoisted_14 = {
  key: 1,
  class: "w-full overflow-hidden"
};
const _hoisted_15 = {
  key: 2,
  class: "w-full flex flex-col items-center justify-center gap-4 pt-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
                                                      
  const _component_LoadingSection = _resolveComponent("LoadingSection");
  const _component_Button = _resolveComponent("Button");
  const _component_SchedulerModal = _resolveComponent("SchedulerModal");
  const _component_Modal = _resolveComponent("Modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [$props.back === false || !this.loading ? (_openBlock(), _createBlock(_component_v_btn, {
    key: 0,
    onClick: $options.BackButtonCallback,
    icon: "icon-previous",
    variant: "tonal",
    size: "small"
  }, null, 8, ["onClick"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
    class: "text-xl font-semibold",
    innerHTML: this.title
  }, null, 8, _hoisted_7), this.flow?.usageRatio ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[4] || (_cache[4] = _createElementVNode("i", {
    class: "icon-diamond text-lg"
  }, null, -1)), _createElementVNode("p", _hoisted_9, _toDisplayString(this.$st('payments.usage-type.' + (this.flow?.usageMeasureUnit ?? 'row'), {
    value: this.flow?.usageRatio
  })), 1)])) : _createCommentVNode("", true)]), this.subtitle ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "text-xs font-light",
    innerHTML: this.subtitle
  }, null, 8, _hoisted_10)) : _createCommentVNode("", true)])]), _cache[5] || (_cache[5] = _createElementVNode("div", {
    id: "header-buttons-teleport-slot",
    class: "flex items-center flex-wrap gap-x-3 gap-y-2 ml-auto"
  }, null, -1)), _renderSlot(_ctx.$slots, "header-slot")]), _renderSlot(_ctx.$slots, "subheader-slot")]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [this.loading ? (_openBlock(), _createBlock(_component_LoadingSection, {
    key: 0
  })) : this.component ? (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(), _createBlock(_resolveDynamicComponent(this.component), {
    key: this.currentSection?.ref,
    props: {
      section: this.currentSection,
      LaunchScript: $options.LaunchScript,
      RepeatTask: $options.RepeatTask,
      ChangeSection: $options.ChangeSection,
      ToggleScheduler: $options.ToggleScheduler,
      OnPaymentError: $options.OnPaymentError,
      ...this.currentSection.params,
      InputComponents: $options.InputComponents,
      InputValues: $options.InputValues
    }
  }, _createSlots({
    next: _withCtx(props => [_createVNode(_component_Button, {
      size: "sm",
      text: this.currentSection.execution ? _ctx.$st('scriptlaunch.launchtask') : _ctx.$st('general.next'),
      icon: this.currentSection.execution ? '' : 'icon-chevron-right',
      onClick: props.callback,
      loading: _ctx.$state.flowLauncherController.loading
    }, null, 8, ["text", "icon", "onClick", "loading"])]),
    repeat: _withCtx(() => [_createVNode(_component_Button, {
      size: "sm",
      text: _ctx.$st('scriptlaunch.repeattask'),
      onClick: _cache[0] || (_cache[0] = $event => this.RepeatTask())
    }, null, 8, ["text"])]),
    console: _withCtx(() => [_ctx.$state.flowLauncherController.output?.consoleLog ? (_openBlock(), _createBlock(_component_Button, {
      key: 0,
      size: "sm",
      variant: this.currentSection?.ref === 'error' ? 'primary' : 'plain',
      text: _ctx.$st('scriptlaunch.showconsole'),
      icon: "icon-warning",
      color: this.currentSection?.ref === 'error' ? '' : 'text-cta2-100',
      reversed: true,
      onClick: _cache[2] || (_cache[2] = $event => _ctx.$state.flowLauncherController.console = !_ctx.$state.flowLauncherController.console)
    }, null, 8, ["variant", "text", "color"])) : _createCommentVNode("", true)]),
    _: 2
  }, [this.currentSection.scheduler ? {
    name: "scheduler",
    fn: _withCtx(props => [_createVNode(_component_Button, {
      variant: "tinted",
      size: "sm",
      text: 'Programar',
      icon: "icon-calendar",
      reverse: true,
      onClick: props.callback
    }, null, 8, ["onClick"])]),
    key: "0"
  } : undefined, _ctx.flow?.instructions ? {
    name: "instructions",
    fn: _withCtx(() => [_createVNode(_component_Button, {
      variant: "outlined_light",
      size: "sm",
      text: "Ver instrucciones",
      onClick: _cache[1] || (_cache[1] = $event => _ctx.$state.ui.drawer = {
        visible: true,
        header: _ctx.$st(this.flow?.name),
        content: _ctx.$sanitizeHtml(_ctx.flow.instructions)
      })
    })]),
    key: "1"
  } : undefined]), 1032, ["props"])), _cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "h-64 w-full shrink-0"
  }, null, -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[7] || (_cache[7] = [_createElementVNode("i", {
    class: "icon-broken-link text-4xl"
  }, null, -1), _createElementVNode("p", {
    class: "text-center"
  }, "Oops!  Something went wrong.", -1)])))])])])]), _ctx.modals.current === 'scheduler-modal' ? (_openBlock(), _createBlock(_component_Modal, {
    key: 0,
    onclose: () => _ctx.modals.current = undefined,
    title: "Elige fecha y hora",
    text: "Y programa la tarea para que se lance automáticamente cuando tu necesites.",
    footer: [{
      size: 'sm',
      variant: 'outlined',
      text: _ctx.$st('general.cancel'),
      click: () => _ctx.modals.current = undefined
    }, {
      size: 'sm',
      text: 'Programar tarea',
      click: $options.OnScheduleCreated
    }]
  }, {
    default: _withCtx(() => [_createVNode(_component_SchedulerModal, {
      modelValue: _ctx.scheduledData,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.scheduledData = $event)
    }, null, 8, ["modelValue"])]),
    _: 1
  }, 8, ["onclose", "footer"])) : _createCommentVNode("", true)], 64);
}

/* Vuetify */
import { VBtn as _component_v_btn } from "vuetify/components/VBtn"

